import {CycleStatusType, UserModel} from '@core/api/data-access';
import {ISignCycle, ISignStation} from '@global-data';

import {SignLandingPageType} from '../sign-landing-pages.types';

export function getTargetSignLandingPage(cycle: ISignCycle, user: UserModel): SignLandingPageType {
	// if the user can sign - return null (no landing page)
	const isSigner = cycle.canSign(user.id);
	if (isSigner) return null;

	// if the user is not a signer - return the appropriate landing page
	switch (cycle.status) {
		case CycleStatusType.Cycling:
			//if user not in the active station, but it was at past station:
			if (!cycle.activeStation$()) {
				if (cycle.pastStations$().some(station => station.canSign(user.id))) return SignLandingPageType.AlreadySigned;
				return SignLandingPageType.NotInActiveStation;
			}
			// check if the user already signed:
			if (cycle.pastStations$()?.some(station => station.canSign(user.id))) return SignLandingPageType.AlreadySigned;

			// check if the user can sign in the future:
			const futureStations: ISignStation[] = cycle.futureStations$();
			if (futureStations.some(station => station.canSign(user.id))) return SignLandingPageType.CanSignInFuture;
			break;

		case CycleStatusType.Canceled:
		case CycleStatusType.Canceling:
			return SignLandingPageType.CycleCanceled;

		case CycleStatusType.Completed:
		case CycleStatusType.Completing:
			return SignLandingPageType.CycleCompleted;

		case CycleStatusType.Denied:
		case CycleStatusType.Denying:
			return SignLandingPageType.CycleRejected;

		case CycleStatusType.Expired:
			return SignLandingPageType.CycleExpired;

		case CycleStatusType.PrivateTemplate:
		case CycleStatusType.PublicTemplate:
		case CycleStatusType.Draft:
		case CycleStatusType.FormFill:
			return SignLandingPageType.CycleNotSignable;
	}
}
